/*jshint esversion: 6 */

import React from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import get from 'lodash/get';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import * as adminActions from '../../actions/adminActions';
import QuizWinner from './QuizWinner';


class CaQuizAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.props.firebase.set(`general/quizzes/${this.props.quizId}/winner`, value.value.value)
            .then(
                response => {
                    // console.log('the value is saved');
                }
            );
    }

    formatSelectedObject(label) {
        return { value: label, label: label };

    }

    getSelectedWinner(general) {

        let quizWinner = get(general, `quizzes.${this.props.quizId}.winner`, undefined);

        if (quizWinner) {
            quizWinner = this.formatSelectedObject(quizWinner);
        }

        return quizWinner;
    }

    formatUsersToOptions(result) {
        let options = result === undefined ?
            [{ value: 'Loading...', label: 'Loading...' }] :
            Object.keys(result).map(key => { return this.formatSelectedObject(key) });

        options.unshift({ value: null, label: "No winner" });

        return options;
    }

    render() {
        return (
            <div>
                <QuizWinner value={this.getSelectedWinner(this.props.general)} options={this.formatUsersToOptions(this.props.quiz)} onChange={this.onChange} />
            </div>
        )


    }
}

let CaQuizAdminComponent = compose(
    connect((state) => ({
        auth: state.firebase.auth,
        general: state.firebase.data.general,
        quiz: state.firebase.data.quiz
    }),
        adminActions),
    firebaseConnect((props, store) => [
        `general`,
        `quiz`
    ]),
)(CaQuizAdmin);

class CaQuizAdminContainer extends React.Component {
    render() {
        if (!this.props.auth.isEmpty)
            return (<CaQuizAdminComponent quizId={this.props.quizId} />);
        else
            return (
                <div>
                    <p>Please login to golden club on abbasite.com to administrate the winner</p>
                </div>
            )


    }
};

export default compose(
    connect((state) => ({ auth: state.firebase.auth })),
    firebaseConnect()
)(CaQuizAdminContainer);
